import React, { useMemo, useEffect, useState, useRef, useContext } from "react";
import PropTypes from "prop-types";

import MobileBlock from "./MobileBlock";
import DesctopBlock from "./DesctopBlock";

import { ADDRESS_SVG } from "../../../../../constants/svgClubConstants";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Link from "next/link";
import { NavbarFooterContext } from "../../containers/NavbarFooterContext";

const MEDIA_SIZE = [
  { minSize: -Infinity, maxSize: 460, count: 1, media: "mob" },
  { minSize: 460, maxSize: 620, count: 2, media: "mob" },
  { minSize: 620, maxSize: 720, count: 2, media: "mob" },
  // { minSize: 620, maxSize: 720, count: 1, media: "desctop" },
  { minSize: 720, maxSize: 1050, count: 2, media: "desctop" },
  { minSize: 1050, maxSize: +Infinity, count: 3, media: "desctop" },
];

const CSS_STYLES = {
  1: {
    0: 46,
  },
  2: {
    0: 21,
    1: 73,
  },
  3: {
    0: 13,
    1: 47,
    2: 82,
  },
  4: {
    0: 10,
    1: 35,
    2: 61,
    3: 87,
  },
};

const HallBlock = ({
  activeHallId,
  setActiveHallId,
  halls,
  //  icon
}) => {
  const [t] = useTranslation();
  const router = useRouter();
  const {
    query: { club },
  } = router;
  // активный размер экрана

  const { scheduleDefaultView } = useContext(NavbarFooterContext);
  const [activeMediaSize, setActiveMediaSize] = useState(null);
  const desctopDescriptionRef = useRef(null);

  useEffect(() => {
    const windowWidth = document.body.clientWidth;

    const activeMediaEl = MEDIA_SIZE.find(
      ({ minSize, maxSize }) => minSize < windowWidth && windowWidth <= maxSize
    );

    setActiveMediaSize(activeMediaEl);
  }, []);
  // при resize проверяем нужно ли поменять сколько ел отображать
  useEffect(() => {
    if (!activeMediaSize) return;

    const resizeFunc = () => {
      const windowWidth = document.body.clientWidth;

      if (
        windowWidth > activeMediaSize.maxSize ||
        windowWidth <= activeMediaSize.minSize
      ) {
        const activeMediaEl = MEDIA_SIZE.find(
          ({ minSize, maxSize }) =>
            minSize < windowWidth && windowWidth <= maxSize
        );

        setActiveMediaSize(activeMediaEl);
      }
    };

    window.addEventListener("resize", resizeFunc);

    return () => window.removeEventListener("resize", resizeFunc);
  }, [activeMediaSize]);

  const { cssArrow = null, posFirstPartHalls = 0 } = useMemo(() => {
    if (!halls || !activeMediaSize) return {};

    const { count } = activeMediaSize;
    let position = null;

    halls.forEach(({ id }, pos) => activeHallId == id && (position = pos));

    const pos = position % count,
      cssArrow = CSS_STYLES[count][pos],
      posFirstPartHalls = count - pos + position;

    return { cssArrow, posFirstPartHalls };
  }, [activeMediaSize, halls, activeHallId]);

  const activeHallData = useMemo(
    () => halls.find(({ id }) => id == activeHallId),
    [activeHallId, halls, posFirstPartHalls]
  );

  const ClubHallDescription = useMemo(() => {
    if (!activeHallData) return;

    const { title, description, offerEnabled, imageTitleEnabled } =
      activeHallData;

    return (
      activeHallData && (
        <div
          className={`club-active-hall ${
            activeMediaSize?.media === "mob" ? "club-active-hall_arrow" : ""
          }`}
          style={cssArrow ? { "--arrow": `${cssArrow}%` } : {}}
        >
          <>
            <h3 className="club-active-hall__description-title">{title}</h3>
            <div
              className="club-active-hall__description-block description-html"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <div className="club-active-hall__address-block">
              <div className="club-active-hall__address-svg">{ADDRESS_SVG}</div>

              <span className="club-active-hall__address">
                {activeHallData.address}
              </span>
            </div>

            {(!imageTitleEnabled || activeMediaSize?.media === "mob") && (
              <Link
                href={{
                  pathname: `/club/${club}/schedule/${scheduleDefaultView}/${+activeHallId}`,
                }}
                className="club-hall-button club-hall-button--mt"
              >
                {t("schedule")}
              </Link>
            )}
            {!!offerEnabled && (
              <div className="club-active-hall__public-contract">
                <Link
                  href={{
                    pathname: `/club/${club}/offer`,
                    query: { hallId: activeHallData.id },
                  }}
                >
                  {t("the_contract")}
                  {/* <Trans i18nKey="the_contract" /> */}
                </Link>
              </div>
            )}

            {/* <div className="club-active-hall__buttons-block">
            <div className="club-active-hall__button">{MAP_SVG}</div>
            <div className="club-active-hall__button">{TAXI_SVG}</div>
          </div> */}
          </>
        </div>
      )
    );
  }, [
    cssArrow,
    activeHallData,
    desctopDescriptionRef,
    activeMediaSize,
    posFirstPartHalls,
    scheduleDefaultView,
    t,
  ]);

  const [firstHalls, setFirstHalls] = useState([]);
  const [secondHalls, setSecondHalls] = useState([]);

  useEffect(() => {
    if (!halls?.length) return;
    if (!posFirstPartHalls) return setFirstHalls(halls);

    setFirstHalls(halls.slice(0, posFirstPartHalls));

    setSecondHalls(halls.slice(posFirstPartHalls));
  }, [halls, posFirstPartHalls, ClubHallDescription]);

  return (
    <>
      {activeMediaSize?.media === "mob" ? (
        <MobileBlock
          firstHalls={firstHalls}
          secondHalls={secondHalls}
          activeMediaSize={activeMediaSize}
          activeHallId={activeHallId}
          setActiveHallId={setActiveHallId}
          ClubHallDescription={ClubHallDescription}
        />
      ) : (
        activeMediaSize?.media === "desctop" && (
          <DesctopBlock
            firstHalls={firstHalls}
            secondHalls={secondHalls}
            activeMediaSize={activeMediaSize}
            activeHallId={activeHallId}
            setActiveHallId={setActiveHallId}
            ClubHallDescription={ClubHallDescription}
            scheduleDefaultView={scheduleDefaultView}
          />
        )
      )}

      <style jsx global>{`
        @import "./HallBlock.scss?7";
        @import "../PerspectiveCard/CardMedia.scss";
      `}</style>
    </>
  );
};

HallBlock.propTypes = {
  halls: PropTypes.array,
  activeHallId: PropTypes.number,
  setActiveHallId: PropTypes.func,
};

HallBlock.defaultProps = {
  halls: [],
  activeHallId: -1,
  setActiveHallId: () => {},
};

export default HallBlock;
